import {
  type LinkProps,
  ListItemButton,
  type ListItemButtonProps,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { ICON, NAVBAR } from '../../config';

type IProps = LinkProps & ListItemButtonProps;

export interface ListItemStyleProps extends IProps {
  activeRoot?: boolean;
  activeSub?: boolean;
  subItem?: boolean;
}

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})<ListItemStyleProps>(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.body1,
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
  color: theme.palette.navBar.menuDefaultText,
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    color: activeRoot || activeSub ? '' : theme.palette.navBar.menuHoverText,
    backgroundColor: activeRoot || activeSub ? '' : theme.palette.navBar.menuHoverBg,
    ...(activeRoot && {
      backgroundColor: theme.palette.navBar.menuActiveBg,
    }),
  },
  ...(activeRoot && {
    ...theme.typography.subtitle2,
    color: theme.palette.navBar.menuActiveText,
    backgroundColor: theme.palette.navBar.menuActiveBg,
  }),
  ...(activeSub && {
    ...theme.typography.subtitle2,
    color: theme.palette.text.primary,
  }),
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
}));

export const ListItemTextStyle = styled(ListItemText)<ListItemButtonProps>(({ theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});
